import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import useCompanyContext from 'common/hooks/useCompanyContext';
import { useCompanyProfile } from 'common/hooks/useCompanyProfile';
import SunshineLoader from 'components/_core/SunshineLoader';

import Accordion from '../../../../../../components/_core/Accordion';
import SunshineCard from '../../../../../../components/_core/SunshineCard';
import Text from '../../../../../../components/_core/Text';
import { useSelectedTaxForecast } from '../../hooks/useSelectedTaxForecastPeriod';
import { useTaxForecastData } from '../../hooks/useTaxForecastData';
import locales from '../../locales';
import EstimationDetails from '../EstimationDetails';
import EmptyState from './components/EmptyState';

const EstimationHistory: FC = () => {
  const [selectedTaxForecast] = useSelectedTaxForecast();
  const {
    currentTaxForecastPeriodId,
    loading: taxForecastLoading,
    taxForecastPeriods,
    taxForecastProfile,
  } = useTaxForecastData();

  const { companyProfileId } = useCompanyContext();
  const { company, loading: companyLoading } =
    useCompanyProfile(companyProfileId);
  const selectedTaxForecastIndex = taxForecastPeriods.findIndex(
    (period) =>
      period.taxForecastPeriodId === selectedTaxForecast?.taxForecastPeriodId,
  );

  if (taxForecastLoading || companyLoading || !company) {
    return <SunshineLoader />;
  }

  return taxForecastPeriods.length ? (
    <>
      <Text fontWeight="weight-500" size="lg" variant="primary">
        {locales.history.title}
      </Text>

      <SunshineCard padding="0">
        <SunshineCard.Content padding="space-0" width="full">
          <Box borderRadius="radius-8" overflow="hidden" width="full">
            <Accordion
              allowMultiple
              allowToggle
              defaultIndex={[selectedTaxForecastIndex]}
            >
              {taxForecastPeriods.map((period, index) => (
                <EstimationDetails
                  hasBorder={index !== taxForecastPeriods.length - 1}
                  includeIncomeTaxInTotal={company.hasPrelevLib}
                  isCurrentPeriod={
                    currentTaxForecastPeriodId === period.taxForecastPeriodId
                  }
                  isPreviousPeriod={index === 1}
                  isSubjectToVAT={taxForecastProfile?.isSubjectToVat}
                  key={period.taxForecastPeriodId}
                  period={period}
                  taxForecastPeriodId={period.taxForecastPeriodId}
                />
              ))}
            </Accordion>
          </Box>
        </SunshineCard.Content>
      </SunshineCard>
    </>
  ) : (
    <EmptyState />
  );
};

export default EstimationHistory;
